import React from 'react';
import { AppBar, Toolbar, Typography, Avatar, Box } from '@mui/material';
import { useAppContext } from '../../context/AppContext';

const Header = () => {
  const { user } = useAppContext();

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
          <img src="/sap-logo.png" alt="SAP Logo" height="32" />
          <Typography variant="h6" component="div">
            SAP Commerce Cloud Portal
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2">{user.name}</Typography>
          <Avatar src={user.avatar} alt={user.name} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
